<template>
  <div id="app">
    <router-view />
    <!-- 右侧客服浮动 -->
    <div class="contact-float">
      <div class="contact-btn" @click="goToCustomerService">
        <span class="contact-title">在线客服</span>
        <img src="@/assets/images/kefu.png" alt="客服" />
        <span class="contact-text">海鸥672106208</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    goToCustomerService() {
      // 跳转到客服页面
      window.open('https://www.yaxin223.com/kefu.htm', '_blank')
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

.contact-float {
  position: fixed;
  right: 5px;
  bottom: 50%;
  transform: translateY(50%);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-btn {
  display: inline-block;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.15);
  width: 104px;
  border-radius: 2px;
  position: relative;
  font-family: "microsoft yahei";
  font-size: 14px;
  background: #fff;
  border: 1px solid #dadee7;
  cursor: pointer;
  text-align: center;
  padding-bottom: 35px;
  
  .contact-title {
    display: inline-block;
    color: #1e2330;
    margin-top: 9px;
  }
  
  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-top: 5px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  
  .contact-text {
    display: block;
    width: 106px;
    height: 35px;
    line-height: 35px;
    position: absolute;
    bottom: -1px;
    left: -1px;
    text-align: center;
    background: #0067ed;
    color: #fff;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
}
</style>
